var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPendingMember = function SvgPendingMember(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0442 6.47754V10.1892L12.9617 11.9675",
    stroke: "#AEAEB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5083 7.2875V7.2875C4.82989 3.55076 8.93048 1.59289 12.6672 2.91449C16.404 4.23608 18.3618 8.33667 17.0402 12.0734C16.2256 14.3768 14.295 16.1075 11.9166 16.6667",
    stroke: "#AEAEB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33333 17.5H2.91667V17.5C2.68655 17.5 2.5 17.3135 2.5 17.0833V16.745V16.745C2.50274 15.7824 3.28239 15.0028 4.24499 15H7.005V15C7.9676 15.0027 8.74725 15.7824 8.75 16.745V17.0833C8.75 17.3135 8.56345 17.5 8.33333 17.5V17.5V17.5Z",
    stroke: "#AEAEB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.62502 12.9167V12.9167C4.70455 12.9167 3.95837 12.1705 3.95837 11.25C3.95838 10.3295 4.70458 9.58337 5.62506 9.58337C6.54292 9.58338 7.28802 10.3255 7.2917 11.2434V11.2434C7.29538 12.1638 6.55217 12.913 5.63171 12.9167C5.62948 12.9167 5.62725 12.9167 5.62503 12.9167L5.62502 12.9167Z",
    stroke: "#AEAEB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgPendingMember as ReactComponent };
export default __webpack_public_path__ + "pending-member.svg";